/**
 * Client-side filtering for the requests table.
 */
export function applyFilters(list, f) {
  return list.filter((item) => {
    if (f.firstName && !item.firstName?.toLowerCase().includes(f.firstName.toLowerCase())) return false;
    if (f.lastName && !item.lastName?.toLowerCase().includes(f.lastName.toLowerCase())) return false;
    if (f.companyName && !item.companyName?.toLowerCase().includes(f.companyName.toLowerCase())) return false;
    if (f.phoneNumber && !item.phoneNumber?.toLowerCase().includes(f.phoneNumber.toLowerCase())) return false;
    if (f.email && !item.email?.toLowerCase().includes(f.email.toLowerCase())) return false;
    if (f.chosenService && !item.chosenService?.toLowerCase().includes(f.chosenService.toLowerCase())) return false;
    if (f.status && !item.status?.toLowerCase().includes(f.status.toLowerCase())) return false;
    if (f.projectName && !item.projectName?.toLowerCase().includes(f.projectName.toLowerCase())) return false;

    if (f.createdDate && item.createdAt) {
      const filterDate = new Date(f.createdDate);
      const itemDate = new Date(item.createdAt);
      if (filterDate.toDateString() !== itemDate.toDateString()) return false;
    }
    if (f.paidDate && item.paidAt) {
      const filterDate = new Date(f.paidDate);
      const itemDate = new Date(item.paidAt);
      if (filterDate.toDateString() !== itemDate.toDateString()) return false;
    }
    if (f.deadline && item.projectDeadline) {
      const filterDate = new Date(f.deadline);
      const itemDate = new Date(item.projectDeadline);
      if (filterDate.toDateString() !== itemDate.toDateString()) return false;
    }

    return true;
  });
}

export function getUniqueFieldValues(requests, field) {
  return Array.from(new Set(requests.map((r) => r[field]).filter(Boolean)));
}
